import { ButtonProps } from '@mui/material/Button';
import * as React from 'react'
import {Colors} from '../Constants'
import withStyles from '@mui/styles/withStyles';

import { Button } from '@mui/material';

export type PPButtonProps = ButtonProps & {
    component?: React.ElementType,
}

export const AdminPrimaryButton = (props: PPButtonProps) => (
    <Button
        color={'primary'}
        variant={'contained'}
        size={'large'} {...props}
    >
        {props.children}
    </Button>
)

export const AdminDefaultButton = (props: PPButtonProps) => (
    <Button color={'info'} variant={'contained'} size={'large'} {...props}>
        {props.children}
    </Button>
)

export const AdminDefaultMediumButton: React.FC<PPButtonProps> = props =>
    <AdminDefaultButton size={'medium'} {...props}>{props.children}</AdminDefaultButton>

export const AdminSecondaryButton = (props: PPButtonProps) => (
    <Button
        color={'secondary'}
        variant={'contained'}
        size={'large'} {...props}
    >
        {props.children}
    </Button>
)

export const AdminPrimaryOutlinedButton = (props: PPButtonProps) => (
    <Button
        color={'primary'}
        variant={'outlined'}
        size={'medium'} {...props}
    >
        {props.children}
    </Button>
)

const AlertStyleButton = withStyles({
    root: {
        color: Colors.Surface,
        backgroundColor: Colors.Alert,
        '&:disabled': {
            color: Colors.Surface,
        }
    },
})(Button)

export const AdminAlertButton = (props: PPButtonProps) => (
    <AlertStyleButton
        color={'secondary'}
        variant={'contained'}
        size={'large'} {...props}
    >
        {props.children}
    </AlertStyleButton>
)
